/**
 * Wording of the folder screens (issue #19, planche 16): the sentence of the
 * deletion dialog and the message after a move, agreed in number.
 */

function matricesPhrase(count: number): string {
  if (count === 0) return 'Ce dossier ne contient aucune matrice.';
  if (count === 1) return "Sa matrice passera hors dossier, elle n'est pas supprimée.";
  return `Ses ${count} matrices passeront hors dossier, elles ne sont pas supprimées.`;
}

function notesPhrase(count: number): string {
  if (count === 0) return 'La description du dossier sera supprimée.';
  if (count === 1) return 'La description et la note du dossier seront supprimées.';
  return `La description et les ${count} notes du dossier seront supprimées.`;
}

/** What the dialog says under « Supprimer le dossier « X » ? ». */
export function deleteFolderDescription(matrixCount: number, noteCount: number): string {
  return `${matricesPhrase(matrixCount)} ${notesPhrase(noteCount)}`;
}

/** « Déplacée dans « X » », or « Déplacée hors dossier » for `null`. */
export function movedMessage(folderName: string | null): string {
  return folderName === null ? 'Déplacée hors dossier' : `Déplacée dans « ${folderName} »`;
}
